import { implementCustomExpressions } from '../__generated/implementation.js';
import { matchesStandardProductHashes } from '../standard-product/standard-product-hash.js';
export const priceExpressions = implementCustomExpressions({
    Shorts: {
        $price: (self, state, context)=>{
            const isStandard = !!context.publishedData.standardProducts?.some((standardProduct)=>{
                return matchesStandardProductHashes(state.entities, standardProduct.entityHashes);
            });
            return isStandard ? self.$standardPrice : self.$standardPrice + self.$customizationSurcharge;
        }
    }
});

//# sourceMappingURL=price.js.map